export default __webpack_public_path__ + "static/media/Local Road - Culvert.6e17f7e4.svg";